<template>
  <h1>Employee Essentials</h1>
  <div class="row screen-height">
    <div class="col-8">
      <div class="row">
        <div class="col-3">
          <IconCard
            label="Overview"
            icon="fa-light fa-book"
          />
        </div>
        <div class="col-3">
          <IconCard
            href="https://app.gusto.com/login"
            target="_blank"
            rel="noopener"
            label="Gusto: Pay"
            :icon="require('@/assets/icons/gusto.svg')"
          />
        </div>
        <div class="col-3">
          <IconCard
            href="https://www.guideline.com/login"
            target="_blank"
            rel="noopener"
            label="Guideline: 401k"
            :icon="require('@/assets/icons/guideline.svg')"
          />
        </div>
        <div class="col-3">
          <IconCard
            label="Healthcare"
            icon="fa-light fa-laptop-medical"
          />
        </div>
        <div class="col-3">
          <IconCard
            label="Schedule Adjustments"
            icon="fa-light fa-calendar-days"
          />
        </div>
        <div class="col-3">
          <IconCard
            href="https://bill.com/login"
            target="_blank"
            rel="noopener"
            label="Bill: Spend & Expense"
            :icon="require('@/assets/icons/bill.svg')"
          />
        </div>
        <div class="col-3">
          <IconCard
            label="Reimbursement Form"
            icon="fa-light fa-receipt"
          />
        </div>
        <div class="col-3">
          <IconCard
            label="Opening Positions"
            icon="fa-light fa-suitcase"
          />
        </div>
      </div>
    </div>
    <div class="col-4">
      <updates-block class="flex-h-100"/>
    </div>
  </div>
</template>

<script>
import UpdatesBlock from '@/components/UpdatesBlock.vue';
import IconCard from '@/components/IconCard.vue';

export default {
  name: 'HrInfo',
  components: {
    UpdatesBlock,
    IconCard,
  },
};
</script>

<style scoped>
[class^="col-"] {
  display: flex; 
  flex-direction: column; 
  box-sizing: border-box;
}
@media (min-width: 700px){
    .footer-secondary{
        padding: 0px !important;
    }
}
@media (max-width: 1100px) {
  /* Tablets - 2 cards per row */
  .col-8 .row .col-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  
  /* Keep the general responsiveness for other columns */
  .col-8, .col-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 700px) {
  /* Mobile - 1 card per row */
  .col-8 .row .col-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.recent-announcement-icon {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 50%;
  background: rgba(255,255,255,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  font-size: 2.5rem;
  color: #fff;
  box-sizing: border-box;
}
</style>